<template>
  <div>
    <header class="header pc-header active">
      <div class="wrap">
        <a href="#" class="logo wow fadeInLeft"
          ><img src="/static/img/logo.png"
        /></a>
        <div class="r-top wow fadeInRight">
          <div class="nav">
            <ul>
              <li :class="{ active: activeIdx == 1 }">
                <a href="#/" class="inNav">首页</a>
              </li>

              <li :class="{ active: activeIdx == 2 }">
                <a href="#/participationCenter" class="inNav">参与中心</a>
              </li>

              <li>
                <!--                <a href="javascript:;" class="inNav">学术支持</a>-->
                <!--                <div class="sub-nav">-->
                <!--                  <a target="_blank" href="https://www.cnki.net/">中国知网</a>-->
                <!--                  <a target="_blank" href="http://www.wanfangdata.com.cn/index.html">万方数据</a>-->
                <!--                  <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/">Pubmed</a>-->
                <!--                  <a target="_blank" href="https://www.embase.com/landing?status=grey">Embase</a>-->
                <!--                  <a target="_blank" href="https://www.cochranelibrary.com/">Cochranelibrary</a>-->
                <!--                </div>-->
                <el-dropdown>
                  <a href="javascript:;" class="inNav">
                    学术支持
                  </a>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">
                      <a target="_blank" href="https://www.cnki.net/"
                        >中国知网</a
                      >
                    </el-dropdown-item>
                    <el-dropdown-item command="b">
                      <a
                        target="_blank"
                        href="http://www.wanfangdata.com.cn/index.html"
                        >万方数据</a
                      >
                    </el-dropdown-item>
                    <el-dropdown-item command="c">
                      <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/"
                        >Pubmed</a
                      >
                    </el-dropdown-item>
                    <el-dropdown-item command="d">
                      <a
                        target="_blank"
                        href="https://www.embase.com/landing?status=grey"
                        >Embase</a
                      >
                    </el-dropdown-item>
                    <el-dropdown-item command="E">
                      <a target="_blank" href="https://www.cochranelibrary.com/"
                        >Cochranelibrary</a
                      >
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
              <!--              <li :class="{'active':activeIdx==6}"><a href="#/meeting" class="inNav">学术会议</a></li>-->
              <li>
                <el-dropdown>
                  <a href="javascript:;" class="inNav ">
                    学术会议
                  </a>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">
                      <a href="#/meeting" class="inNav">2021 COC</a>
                    </el-dropdown-item>
                    <el-dropdown-item command="b">
                      <a href="#/meeting2023" class="inNav">2023 COC</a>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
              <li :class="{ active: activeIdx == 4 }">
                <a href="#/publish" class="inNav">发表论文</a>
              </li>
              <li :class="{ active: activeIdx == 5 }">
                <a href="#/joinUs" class="inNav">加入我们</a>
              </li>
            </ul>
          </div>
          <!--          <a target="_blank" href="https://follower.edocdata.com/statistics" class="apply-data-btn">数据统计</a>-->
          <a @click="openDialog" href="javascript:;" class="apply-data-btn"
            >申请数据</a
          >
        </div>
      </div>
    </header>
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
    >
      <ApplicationData />
    </el-dialog>
  </div>
</template>

<script>
import ApplicationData from "./applicationData";
export default {
  data() {
    return {
      activeIdx: 1,
      dialogVisible: false
    };
  },
  components: { ApplicationData },
  mounted() {
    this.refreshActive();
  },
  watch: {
    $route(f, b) {
      if (f.path != b.path) {
        this.refreshActive();
      }
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    openDialog() {
      this.dialogVisible = true;
    },
    refreshActive() {
      let routeName = this.$route.name;
      if (routeName == "Meeting") {
        this.activeIdx = 6;
      } else if (routeName == "JoinUs") {
        this.activeIdx = 5;
      } else if (routeName == "Publish") {
        this.activeIdx = 4;
      } else if (routeName == "ParticipationCenter") {
        this.activeIdx = 2;
      } else if (routeName == "index") {
        this.activeIdx = 1;
      }
    }
  }
};
</script>

<style scoped>
/* @import url('../../static/css/swiper.min.css'); */
/*@import url('../../static/css/common.css');*/
/* @import url('../../static/css/index.css'); */
/* @import url('../../static/css/respond.css'); */
</style>



// WEBPACK FOOTER //
// src/components/header.vue